import { func, number } from 'prop-types'
import { Component } from 'react'
import { Size } from '@opallabs/gem'
import { kuiperClassNames, Menu, PopoverV2 } from '@opallabs/kuiper'
import { Icon } from '@opallabs/lapidary'
import { trackCanvasSlideCreation } from '../Helpers/eventsTracking'

import './styles.scss'

const layouts = [
  {
    label: 'Section header',
    layout: 'section_header',
    glyph: 'layout-section-header',
  },
  {
    label: 'Basic text',
    layout: 'basic_text',
    glyph: 'layout-text',
  },
  {
    label: 'Text & Image',
    layout: 'text_and_image',
    glyph: 'layout-text-image',
  },
  {
    label: 'Image only',
    layout: 'image_only',
    glyph: 'layout-image',
  },
]

class SlideSelector extends Component {
  static propTypes = {
    createSlide: func,
    presentationId: number,
  }

  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  createSlideAndTrack = (layout) => {
    const createSlideArgs = {
      layout,
      presentationId: this.props.presentationId,
    }

    trackCanvasSlideCreation(createSlideArgs)

    if (this.props.createSlide) {
      this.props.createSlide(createSlideArgs)
    }
  }

  onSlideSelection = ({ id }) => {
    this.createSlideAndTrack(id)
    this.closePopover()
  }

  updateOpen = (value) => {
    this.setState({ open: value })
  }

  openPopover = () => {
    this.updateOpen(true)
  }

  closePopover = () => {
    this.updateOpen(false)
  }

  get trigger() {
    return (
      <button
        className={kuiperClassNames('trigger-icon')}
        onClick={this.openPopover}
      >
        <span className="sr-only">Add a slide…</span>
        <Icon
          ariaHidden={true}
          glyph="gem-add"
          height={Size.Icon * 1.75}
          width={Size.Icon * 1.75}
        />
      </button>
    )
  }

  renderPopoverContent = () => {
    const options = layouts.map((slide) => ({
      icon: (
        <Icon
          ariaHidden={true}
          glyph={slide.glyph}
          height={Size.Icon * 2.25}
          useHypernova={true}
          width={Size.Icon * 3}
        />
      ),
      id: slide.layout,
      title: slide.label,
    }))

    return (
      <Menu
        canSelectAll={false}
        className={kuiperClassNames('slide-options-container')}
        multiple={false}
        onSelect={this.onSlideSelection}
        options={options}
        role="listbox"
        rowHeight={Size.Icon * 2.625}
      />
    )
  }

  render() {
    return (
      <div className={kuiperClassNames('slide-selector')}>
        <PopoverV2
          className={kuiperClassNames('slide-selector-popover')}
          popoverHandlers={{
            open: this.state.open,
          }}
          onClosed={this.closePopover}
          trigger={this.trigger}
          content={this.renderPopoverContent}
        />
      </div>
    )
  }
}

export default SlideSelector
